module.exports = __webpack_public_path__ + "static/media/galeryCeilings1.0dd3ac7d.jpg";